<panel width="800">
    <form>
        <h1>{{ 'invoice.edit-invoice-payments.header' | translate }}</h1>
        <section three-columns>
            <div><custom-select [selectList]="installmentNumbers" [required]="true" [label]="'invoice.edit-invoice-payments.number-of-remaining-installments' | translate" [(value)]="numberOfRemainingInstallments" (valueChange)="calculatePayments()" [allowAutoFocus]="false" /></div>
            <div><custom-select [selectList]="paymentIntervals" [required]="true" [label]="'invoice.edit-invoice-payments.interval' | translate" [(value)]="interval" (valueChange)="calculatePayments()" /></div>
            <div><date-input [required]="true" [label]="'invoice.edit-invoice-payments.next-due-date' | translate" [minDate]="today" [(value)]="nextDueDate" (valueChange)="calculatePayments()" /></div>
        </section>
        <list-view scrollable [selectable]="false">
            <header>{{ 'invoice.installment-payments.due-date' | translate }}</header>
            <header>{{ 'invoice.installment-payments.status' | translate }}</header>
            <header align-right>{{ 'invoice.installment-payments.amount-incl-vat' | translate }}</header>
            <header></header>
            <row *listData="let payment from payments; let listData=listData" [clickable]="false" statusColor="getStatusColor(payment)">
                @if (payment.paid) { <column>{{ payment.dueDate | customDate: 'shortDate' }}</column> }
                @else { <column><date-input [required]="true" [minDate]="today" [(value)]="payment.dueDate" /></column> }
                <column>{{ (payment.paid ? 'invoice.installment-payments.status.paid' : 'invoice.installment-payments.status.unpaid') | translate }}</column>
                @if (payment.paid) { <column align-right>{{ payment.amount | currency }}</column> }
                @else { <column align-right><custom-input [inputType]="inputType.Currency" [(value)]="payment.amount" [required]="true" textAlign="right" /></column> }
                <column><icon type="arrow-alt-from-top" (click)="copyDown(payment, listData.sortedObjects)" [title]="'invoice.installment-payments.copy-value-downwards' | translate" /></column>
            </row>
            <row [clickable]="false" [statusColor]="validPayments() ? 'color-green-50' : 'color-red-50'">
                <column>{{ validPaymentsStatus | translate }}</column>
                <column />
                <column align-right>{{ differenceBetweenPaymentsAndRemainingAmount | currency }}</column>
                <column />
            </row>
        </list-view>
        <section>
            <button ghost (click)="close()" [label]="'general.cancel' | translate"></button>
            @if (onlyUnpaidInstallments) {
                <button reject (click)="cancelAllPayments()" [label]="'invoice.installment-payments.cancel-all-payments' | translate"></button>
            }
            <button confirm [active]="validPayments()" (click)="saveUpcomingPayments()" [label]="'general.save' | translate"></button>
        </section>
    </form>
</panel>
